import { shouldClientReconnect } from '../../../network/should-client-reconnect';
import { WebSocketCodes } from '../../../network/websocket-codes';
import { type SocketMachineContext } from '../../network-state-machine-context';
import { type CloseEvent } from '../../network-state-machine-events';

export function isSessionRevoked(_: SocketMachineContext, event: CloseEvent) {
  return event.code === WebSocketCodes.SESSION_REVOKED;
}

export function isPossibleToRetry(_: SocketMachineContext, event: CloseEvent) {
  return shouldClientReconnect(event.code);
}

export function resetDebounce(context: SocketMachineContext) {
  context.debounce.resetAttempts();
  return context;
}
